import React, { useRef } from 'react';
import {
  DropdownMenuProps,
  DropdownMenuType,
} from './DropdownMenu/DropdownMenu.props';
import { useDropdownMenuState } from './DropdownMenu/DropdownMenu.state';
import {
  DropdownMenuProvider,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuDivider,
  DropdownMenuView,
} from './DropdownMenu/DropdownMenu.view';
// This file defines the main DropdownMenu component, integrating state management, context provision, and view rendering to create a reusable and configurable dropdown menu system. It also exports sub-components for building the menu's structure and content.
const DropdownMenuComponent: React.FC<DropdownMenuProps> = ({
  trigger,
  items,
  size = 'md',
  variant = 'default',
  side = 'bottom',
  align = 'start',
  defaultOpen = false,
  views,
  ...props
}) => {
  const { isOpen, setIsOpen, activeSubmenuId, setActiveSubmenuId } =
    useDropdownMenuState(defaultOpen);
  const triggerRef = useRef<HTMLElement>(null);
  return (
    <DropdownMenuProvider
      value={{
        isOpen,
        setIsOpen,
        activeSubmenuId,
        setActiveSubmenuId,
        size,
        variant,
        triggerRef,
      }}
    >
      <DropdownMenuView
        trigger={trigger}
        items={items}
        side={side}
        align={align}
        views={views}
        {...props}
      />
    </DropdownMenuProvider>
  );
};
export const DropdownMenu = DropdownMenuComponent as DropdownMenuType;
DropdownMenu.Trigger = DropdownMenuTrigger;
DropdownMenu.Content = DropdownMenuContent;
DropdownMenu.Item = DropdownMenuItem;
DropdownMenu.Divider = DropdownMenuDivider;
